// extracted by mini-css-extract-plugin
export default {"error":"styles_error__usxCI","interface-info":"styles_interface-info__xfd9L","icon":"styles_icon__KGnqe","text":"styles_text__2rDis"};